import { http } from './http'
import { i18n } from '@/translations/i18n'
import { punctToSlash } from '@/helper'

export default {
  getItems(target, params) {
    return http.get(punctToSlash(target), {
      params: {
        locale: i18n.formatedLocale,
        ...params,
      },
    })
  },
  getItem(target, params) {
    return http.get(punctToSlash(target), {
      params: {
        locale: i18n.formatedLocale,
        ...params,
      },
    })
  },
  editItem(target, params) {
    return http.put(punctToSlash(target), {
      locale: i18n.formatedLocale,
      ...params,
    })
  },
  createItem(target, data) {
    return http.post(punctToSlash(target), data, {
      params: {
        locale: i18n.formatedLocale,
      },
    })
  },
  deleteItem(target, data, params) {
    return http.delete(punctToSlash(target), {
      data,
      params: {
        locale: i18n.formatedLocale,
        ...params,
      },
    })
  },
}
